import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../Box/Box.web.js';
import { px2rem, setTransitionProps } from '../utils/helpers/style.js';
import { useTheme } from '../utils/theming/useTheme.js';
import { IconError } from '../icons/ui_general/IconError.web.js';
import { isErrorIconVisible } from './utils.js';
import { spacing } from '../constants/spacing.js';
import { timings } from '../constants/timings.js';

var ErrorMessage = function ErrorMessage(_ref) {
  var active = _ref.active,
      textColor = _ref.textColor,
      children = _ref.children,
      id = _ref.id,
      errorRef = _ref.errorRef,
      showIcon = _ref.showIcon,
      props = _objectWithoutProperties(_ref, ["active", "textColor", "children", "id", "errorRef", "showIcon"]);

  var inactiveProps = {
    maxHeight: 0,
    opacity: 0,
    padding: 0
  };
  var theme = useTheme();
  var errorMessageTheme = theme.errorMessage.web;
  var isIconVisible = isErrorIconVisible(theme, 'web', showIcon);
  return /*#__PURE__*/React.createElement(Box, _extends({
    id: id,
    "data-test": id && "elemental-Error-".concat(id),
    display: "flex",
    alignItems: "center",
    textColor: textColor ? textColor : errorMessageTheme.color,
    overflow: "hidden",
    maxHeight: px2rem(160),
    opacity: 1,
    pt: spacing.xxxs
  }, setTransitionProps({
    padding: timings.slowest,
    'max-height': timings.slowest,
    opacity: timings.slowest
  }), {
    boxRef: errorRef
  }, !active && inactiveProps, props), isIconVisible && /*#__PURE__*/React.createElement(IconError, {
    size: 24
  }), /*#__PURE__*/React.createElement(Box, {
    "aria-hidden": active ? undefined : true,
    pl: isIconVisible ? spacing.xxxs : undefined,
    "data-test": id && "elemental-Error-".concat(id, "-content")
  }, children));
};

export { ErrorMessage };
